import CategoryList from './category-list';

export default CategoryList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/CategoryList/index.jsx